
    import Vue from 'vue';
    import AsModal from '@/components/Ui/AsModal.vue';
    import AsHeadline from '@/components/Ui/AsHeadline.vue';
    import { settingsHelper } from '@/store/modules/settings';
    import { i18nTemplateString } from '@/util/i18n';    
    const settingsHelpers = settingsHelper.mapGetters(['termsConditions']);

    export default Vue.extend({
        name: 'TermsOfService',
        components: {
            AsModal,
            AsHeadline,
        },
        data(): { component: any } {
            return {
                component: null,
            };
        },
        computed: {
            ...settingsHelpers,
            loader() {
                console.log('loading', this.termsConditions);
                return () => import(`../TermsOfService/${this.termsConditions}.vue`);
            },
            title(): string {
				return i18nTemplateString('{i18n.termsModal.title}', (x) => this.$t(x))
			}
        },
        methods: {
            loadComponent(name: string) {
                return this.loader()
                    .then(() => {
                        this.component = () => this.loader();
                    })
                    .catch(() => {
                        console.log('failed loading', this.termsConditions);
                        this.component = () => import('../TermsOfService/StandardTermsOB.vue');
                    });
            },
        },
        watch: {
            termsConditions: {
                handler: 'loadComponent' as any,
                immediate: true,
            },
        },
    });
